import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setIsLoading, setToastMessage } from "../reducers/common.reducer";
import { getAgentService } from '../services/agent.service';

const useAgentData = () => {
    const [agentData, setAgentData] = useState(null);

    const dispatch = useDispatch();

    async function getAgentData (signal) {
            
        try {
            dispatch(setIsLoading(true))
            let result = await getAgentService(signal);
            if(result.data) {
                setAgentData(result.data);
            }
        }
        catch (error) {
            dispatch(
                setToastMessage({
                message: error?.response?.data?.message || error?.message,
                type: "error",
                })
            );
        }
        finally {
            dispatch(setIsLoading(false))
        }
    }

    useEffect(() => {
            
        const controller = new AbortController();
        const signal = controller.signal;
        getAgentData(signal);

        return () => {
            controller.abort();
        }
    }, []);


    return [agentData, setAgentData]
}

export default useAgentData